<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>发布需求</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div class="form-title text-center" style="margin-bottom: 40px;">发布项目需求</div>
            <div class="pro-info-box" style="justify-content: space-between">
                <div class="box" style="max-width: 80%">
                    <div class="box__label">项目名称:</div>
                    <div class="box__item" style="max-width: 80%">
                        <el-tooltip :content="info.name">
                            <div class="content-ellipsis">{{info.name}}</div>
                        </el-tooltip>
                    </div>
                </div>
                <div class="box">
                    <div class="box__label">预计完成时间:</div>
                    <div class="box__item">
                        {{info.complete_time}}
                    </div>
                </div>
            </div>
            <div class="table striped--header" style="margin-top: 20px;">
                <el-table
                    :data="info.pretreatment"
                >
                    <el-table-column
                        prop="name"
                        align="center"
                        width="200"
                        :show-overflow-tooltip="true"
                        label="服务名称">
                    </el-table-column>
                    <el-table-column
                        prop="unit"
                        align="center"
                        label="单位">
                    </el-table-column>
                    <el-table-column
                        prop="amount"
                        align="center"
                        label="预估人数">
                    </el-table-column>
                    <el-table-column
                        label="预估单价"
                        align="center"
                        prop="price">
                    </el-table-column>
                    <el-table-column
                        label="预估总价"
                        align="center"
                        width="140"
                        prop="money">
                    </el-table-column>
                </el-table>
<!--                 <div class="table__like">
                    <div class="td">平台综合服务费</div>
                    <div class="td-flex"></div>
                    <div class="td">{{info.service_fee}}</div>
                </div> -->
                <div class="table__like">
                    <div class="td">总计</div>
                    <div class="td-flex"></div>
                    <div class="td">{{info.total}}</div>
                </div>
            </div>
            <div class="creator_ft">
                <div class="box">
                    <el-button @click="goPage(`/index/project`)">取消</el-button>
                </div>
                <div class="box">
                    <el-button type="primary" @click="onSubmit">提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Commit',
    inject: ['goPage'],
    data () {
        return {
            info: {}
        }
    },
    mounted () {
        if (window.localStorage.getItem('PREADD')) {
            this.info = JSON.parse(window.localStorage.getItem('PREADD'))
            localStorage.removeItem('PREADD')
        } else {
            router.replace('/index/project/add')
            throw new Error('获取本地PREADD失败')
        }
    },
    methods: {
        onSubmit () {
            if (this.info.id * 1 !== this.$route.query.id * 1) {
                localStorage.removeItem('PREADD')
                this.$message.error('系统错误，请重新发布项目')
                router.replace('/index/project/add')
            } else {
                this.$http.post('/api/user/project/commit', qs.stringify({
                    id: this.info.id
                }))
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '项目发布成功。'
                            })
                            router.push(`/index/project/detail?id=${res.data.id}`)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";

    .pro-info-box {
        margin-top: 20px;
    }

    .table__like {
        display: flex;
        border-bottom: 1px solid $--border-color-light;

        .td-flex {
            flex: 1;
        }

        .td {
            text-align: center;
            padding: 12px 0;
            line-height: 23px;

            &:first-child {
                width: 200px;
            }

            &:last-child {
                width: 140px;
            }
        }
    }
</style>
